Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in
   * the DOM
   * @param {callable} callback The callback function applied to every element
   * matching the selector
   */
  'facility_list',
  '.sc-facility-list',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in
   * data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching
   * the selector
   * @param {string} selector The shortcode selector passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $widget = $(el);
    const $facilities = $widget.find(`${selector}__facilities`);
    const $sortButtons = $widget.find(`${selector}__sort-button`);
    const $pagination = $widget.find(`${selector}__pagination`);
    const $paginationPrev = $pagination.find(`${selector}__pagination-button--prev`);
    const $paginationNext = $pagination.find(`${selector}__pagination-button--next`);
    const $paginationRange = $pagination.find(`${selector}__pagination-range`);
    const template = $widget.find(`${selector}__facility-template`).html();

    let activeRequest = null;
    let activeSort = model.sort || ['name:asc'];
    let page = 0;
    const lastPage = Math.max(0, Math.ceil(model.total / model.max) - 1);

    (function init() {
      addEvents();
    })();


    /**
     * Add click listeners
     */
    function addEvents() {
      $widget.on('click', `${selector}__facility-header`, toggleFacilityInfo);
      $sortButtons.on('click', sortFacilities);
      $paginationPrev.on('click', goToPreviousPage);
      $paginationNext.on('click', goToNextPage);
    }


    /**
     * Toggle visibility of the facility info
     * @param {*} event
     */
    function toggleFacilityInfo(event) {
      const $target = $(event.currentTarget).closest(`${selector}__facility`);
      $target.toggleClass('open');
    }


    /**
     * Sort facilities using the selected button.
     * @param {*} event
     */
    function sortFacilities(event) {
      let $button = $(event.currentTarget);
      event.preventDefault();

      if ($button.hasClass('active')) {
        $button.prop('hidden', true);
        $button = $button
          .siblings(`[data-sort="${$button.attr('data-sort')}"]`)
          .prop('hidden', false)
          .trigger('focus');
      }

      const fields = $button.data('sort').toString().split(',');
      const directions = $button.data('sort-direction').toString().split(',');
      activeSort = fields.map((field, index) => {
        const direction = directions[index] || directions[0];
        return `${field}:${direction}`;
      });

      $sortButtons
        .filter('.active')
        .removeClass('active')
        .attr('aria-pressed', 'false');
      $button
        .addClass('active')
        .attr('aria-pressed', 'true');

      page = 0;
      fetchFacilities();
    }


    /**
     * Go to the previous page of facilities.
     * @param {*} event
     */
    function goToPreviousPage(event) {
      event.preventDefault();

      if (page <= 0) {
        return;
      }

      page -= 1;
      fetchFacilities();
    }


    /**
     * Go to the next page of facilities.
     * @param {*} event
     */
    function goToNextPage(event) {
      event.preventDefault();

      if (page >= lastPage) {
        return;
      }

      page += 1;
      fetchFacilities();
    }


    /**
     * Fetch sorted facilities and replace the rendered list.
     */
    function fetchFacilities() {
      const params = {
        region_id: model.region_id,
        filters: model.filters || {},
        max: model.max,
        offset: page * model.max,
        sort: activeSort,
      };

      if (activeRequest && activeRequest.readyState !== 4) {
        activeRequest.abort();
      }

      $widget.addClass(`${className}--loading`);
      $paginationPrev.prop('disabled', true);
      $paginationNext.prop('disabled', true);

      const request = $.ajax({
        url: model.rest_url,
        method: 'GET',
        data: params,
      });

      activeRequest = request;

      request.done(function(response) {
        const facilities = response.facilities || [];
        $facilities.html(facilities.map(renderFacility).join(''));
        updatePagination(facilities.length);
      });

      request.fail(function(jqXHR, textStatus) {
        if (textStatus !== 'abort') {
          syncPaginationButtons();
        }
      });

      request.always(function() {
        if (request === activeRequest) {
          $widget.removeClass(`${className}--loading`);
          activeRequest = null;
        }
      });
    }


    /**
     * Enable/disable the prev/next buttons based on the current page.
     */
    function syncPaginationButtons() {
      if (!$pagination.length) {
        return;
      }

      $paginationPrev.prop('disabled', page <= 0);
      $paginationNext.prop('disabled', page >= lastPage);
    }


    /**
     * Update the pagination range text and prev/next button states.
     * @param {number} count Number of facilities in the current page.
     */
    function updatePagination(count) {
      if (!$pagination.length) {
        return;
      }

      const from = (page * model.max) + 1;
      const to = from + count - 1;

      $paginationRange.text(`${from.toLocaleString()}–${to.toLocaleString()} of ${model.total.toLocaleString()}`);
      syncPaginationButtons();
    }


    /**
     * Render a facility row using the embedded Mustache template.
     * @param {object} facility
     * @return {string}
     */
    function renderFacility(facility) {
      return Mustache.render(
        template,
        $.extend({
          _block: className,
        }, facility)
      );
    }

  });
